// extracted by mini-css-extract-plugin
module.exports = {"scene":"WhatsNewScene_scene__kbfeh"};